








import BaseState from '@spa/components/pages/paid-membership/unsubscribe/state/BaseState.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

/**
 * 解約済みあるいは契約したことが無いなど、契約中の状態でない場合の表示
 */
@Component({
  components: { BaseState },
})
export default class NotSubscribedNow extends Vue {
}
